<div class="folder-contents" *ngIf="!showViewer">
  <div class="browser-header d-flex align-items-center justify-content-between mt-3 mb-3">
    <div class="d-flex align-items-center">
      <button mat-icon-button (click)="onBack()" class="me-2">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="mb-0">{{ folderName }}</h4>
    </div>
  </div>

  <div class="personal-data-blue p-3 rounded-3 mt-3">
    <form [formGroup]="filterForm">
      <div class="d-flex top-form-filter gap-3 align-items-end">
        <div class="filter-field">
          <label for="file_type" class="text-muted fs-14">{{ 'fileType.file' | translate }}</label>
          <select
            name="file_type"
            id="file_type"
            class="form-select rounded-1 text-muted fs-14 shadow-none"
            aria-placeholder="select"
            formControlName="file_type"
            (change)="onFilterChange($event, 'file_type')"
          >
            <option class="select-placehoder" selected value="">
              {{ 'fileType.select' | translate }}
            </option>
            @for (fileType of fileTypes; track fileType?.id || $index) {
              <option [value]="fileType?.id">
                {{ fileType?.name | titlecase }}
              </option>
            }
          </select>
        </div>

        <div class="filter-field">
          <label for="start_date" class="text-muted fs-14">{{
            'auditTrailCmeRequest.placeholder.selectDateRange' | translate
          }}</label>

          <educare-date-range-picker
            [formGroup]="filterForm"
            [placeholder]="'auditTrailCmeRequest.placeholder.selectDateRange' | translate"
            (dateChange)="applyDateFilter($event)"
          ></educare-date-range-picker>
        </div>
        <div class="filter-field">
          <label for="uploaded_by" class="text-muted fs-14">{{ 'fileType.update' | translate }}</label>
          <input
            type="text"
            name="uploaded_by"
            id="uploaded_by"
            class="form-control rounded-1 text-muted fs-14 shadow-none"
            placeholder="{{ 'fileType.name' | translate }}"
            formControlName="uploaded_by"
            (input)="onFilterChange($event, 'uploaded_by')"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="browser-content personal-data-blue p-3 rounded-3">
    <div
      *ngIf="enableSelection && hasSelectedItems"
      class="selection-actions mb-3 d-flex justify-content-between align-items-center"
    >
      <span class="selection-count text-primary">
        {{ selectedItems.length }} {{ 'common.itemsSelected' | translate }}</span
      >

      <div class="d-flex gap-2">
        <button class="btn btn-primary" type="button" (click)="openAreaOfInterestDialog()">
          {{ 'common.areaOfInterest.label' | translate }}
        </button>
        <button class="btn btn-primary" (click)="openGrantAccessDialog(false)">
          {{ 'common.grantAccess' | translate }}
        </button>
        <button class="btn btn-primary" (click)="openGrantAccessDialog(true)">
          {{ 'common.revokeAccess' | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="loading-container d-flex justify-content-center align-items-center py-5">
      <mat-icon class="spin">refresh</mat-icon>
      <span class="ms-2">{{ 'common.loading' | translate }}</span>
    </div>

    <div *ngIf="!loading && !hasResults" class="no-results text-center py-5">
      <p class="text-muted">{{ 'common.noResultsFound' | translate }}</p>
    </div>

    <div *ngIf="!loading && hasResults">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="fs-5 mb-0 text-muted">{{ 'common.content' | translate }}</h5>
        <div class="view-toggle d-flex gap-2">
          <div class="filter-sort">
            <div [formGroup]="filterForm">
              <select
                name="sort_by"
                id="sort_by"
                class="form-select rounded-1 text-muted fs-14 shadow-none"
                aria-placeholder="select"
                formControlName="sort_by"
                (change)="onFilterChange($event, 'sort_by')"
              >
                <option class="select-placehoder" selected value="">
                  {{ 'sortingFilter.sortBy' | translate }}
                </option>
                <optgroup label="{{ 'sortingFilter.sortByField' | translate }}">
                  @for (sortOption of sortOptions; track sortOption?.id || $index) {
                    <option [value]="sortOption?.id">
                      {{ sortOption?.name }}
                    </option>
                  }
                </optgroup>
                <optgroup label="{{ 'sortingFilter.sortOrder' | translate }}">
                  @for (sortOrder of sortOrder; track sortOrder?.id || $index) {
                    <option [value]="sortOrder?.id">
                      {{ sortOrder?.name }}
                    </option>
                  }
                </optgroup>
              </select>
            </div>
          </div>
          <educare-view-mode-toggle
            [viewMode]="viewMode"
            (viewModeChange)="onViewModeToggle($event)"
          ></educare-view-mode-toggle>
        </div>
      </div>
    </div>
    <!-- Grid View -->
    <div *ngIf="!loading && hasResults && viewMode === 'grid'" class="grid-view">
      <div class="grid-select-all mb-3" *ngIf="enableSelection">
        <mat-checkbox
          [checked]="selectAll"
          [indeterminate]="selectedItems.length > 0 && selectedItems.length < totalItems"
          (change)="onTableSelectAllAcrossPages($event.checked)"
        >
          {{ 'common.selectAll' | translate }}
        </mat-checkbox>
      </div>
      <div #gridContainer class="grid-container">
        <mat-card *ngFor="let item of paginatedItems; trackBy: trackByFn" class="item-card">
          <div
            (click)="onItemClick(item)"
            (keydown.enter)="onItemClick(item)"
            (keydown.space)="onItemClick(item)"
            tabindex="0"
            role="button"
          >
            <mat-card-header
              [ngClass]="{ 'graybg-header': item.type === 'folder', 'bluebg-header': item.type === 'file' }"
              class="custom-header d-flex justify-content-center align-items-center"
            >
              <educare-file-icon
                [iconType]="getFileIcon(item)"
                size="large"
                [containerClass]="item.type === 'folder' ? 'folder-icon' : 'document-icon'"
              ></educare-file-icon>
            </mat-card-header>
            <mat-card-content class="d-flex flex-column text-start">
              <div class="d-flex">
                <div *ngIf="enableSelection" class="grid-item-checkbox">
                  <mat-checkbox
                    [checked]="isItemSelected(item)"
                    (change)="toggleItemSelection(item, $event.checked)"
                    (click)="$event.stopPropagation()"
                  ></mat-checkbox>
                </div>
                <div class="grid-content">
                  <h6 class="item-name fs-18 mt-2 mb-1" [matTooltip]="item.name">{{ item.name }}</h6>
                  <div class="item-details">
                    <p class="fs-12 mb-1">{{ item.updatedDate }}</p>
                    <p class="fs-12 mb-0">
                      <span *ngIf="item.type === 'folder'">{{ item.fileCount }} {{ 'common.files' | translate }}</span>
                    </p>
                  </div>
                </div>
                <div *ngIf="enableSelection" class="d-flex gap-2">
                  <button
                    [matTooltip]="'common.areaOfInterest.label' | translate"
                    matTooltipPosition="below"
                    class="action-btn"
                    (click)="openAreaOfInterestDialog([item.id]); $event.stopPropagation()"
                    [disabled]="selectedItems.length > 0"
                  >
                    <i class="das das-bookmark_heart"></i>
                  </button>
                  <!-- Grant Access Button -->
                  <button
                    [matTooltip]="'common.grantAccess' | translate"
                    matTooltipPosition="below"
                    class="action-btn"
                    (click)="openGrantAccessDialog(false, item); $event.stopPropagation()"
                    [disabled]="selectedItems.length > 0"
                  >
                    <i class="das das-article_person"></i>
                  </button>

                  <!-- Revoke Access Button -->
                  <button
                    [matTooltip]="'common.revokeAccess' | translate"
                    matTooltipPosition="below"
                    class="action-btn"
                    (click)="openGrantAccessDialog(true, item); $event.stopPropagation()"
                    [disabled]="selectedItems.length > 0"
                  >
                    <i class="das das-undo"></i>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </div>
        </mat-card>
      </div>

      <!-- Pagination for Grid View -->
      <div class="grid-footer d-flex justify-content-end align-items-center mt-3">
        <mat-paginator
          *ngIf="showPagination && totalItems > 0"
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageIndex]="currentPage"
          [hidePageSize]="true"
          (page)="onPageChange($event)"
          showFirstLastButtons="true"
        ></mat-paginator>
      </div>
    </div>

    <!-- List View -->
    <div *ngIf="!loading && hasResults && viewMode === 'list'" class="list-view">
      <div class="table-page">
        <educare-table
          [dataSource]="tableDataSource"
          [columns]="tableColumns"
          [selectionConfig]="tableSelectionConfig"
          (pageChange)="onPageChange($event)"
          (selectionChange)="onTableSelectionChange($event)"
          (selectAllAcrossPages)="onTableSelectAllAcrossPages($event)"
        ></educare-table>
      </div>
    </div>
  </div>
</div>

<educare-document-viewer *ngIf="showViewer && selectedDocument" [document]="selectedDocument" (back)="onViewerBack()">
</educare-document-viewer>
